module.exports = __webpack_public_path__ + "media/application/images/svgs/droplet-4456d92bcb1b5fe25411ab124b1ee0d8.svg";